<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('projectProfile.code')
                }}</label>
                <input
                  v-model="model.project_code"
                  type="text"
                  class="form-control"
                  placeholder="Input project code. ex: 0000-000"
                />
                <div class="validate" v-if="errors.has('project_code')">
                  {{ errors.first('project_code') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('projectProfile.name')
                }}</label>
                <input
                  v-model="model.project_name"
                  type="text"
                  class="form-control"
                  placeholder="Input project name. ex: UX/UI Design"
                />
                <div class="validate" v-if="errors.has('project_name')">
                  {{ errors.first('project_name') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 required ts-font-robot">{{
                  $t('projectProfile.status')
                }}</label>
                <a-select
                  v-model="model.status_id"
                  :options="projectStatus"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select who is main response"
                ></a-select>
                <div class="validate" v-if="errors.has('status_id')">
                  {{ errors.first('status_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.priority')
                }}</label>
                <a-select
                  v-model="model.priority_id"
                  :options="priorities"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select who is main response"
                ></a-select>
                <div class="validate" v-if="errors.has('priority_id')">
                  {{ errors.first('priority_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.owner')
                }}</label>
                <a-select
                  v-model="model.project_owner"
                  :options="owners"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select who is main response"
                ></a-select>
                <div class="validate" v-if="errors.has('project_owner')">
                  {{ errors.first('project_owner') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.estimated')
                }}</label>
                <a-range-picker
                  v-model="model.estimated_date"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  class="ts-w-full"
                />
                <div class="validate" v-if="errors.has('estimated_date')">
                  {{ errors.first('estimated_date') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot ts-capitalize">{{
                  $t('projectProfile.actual')
                }}</label>
                <a-range-picker
                  v-model="model.actual_date"
                  format="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  class="ts-w-full"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.customer')
                }}</label>
                <a-select
                  v-model="model.customer_id"
                  :options="customers"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select customer name"
                ></a-select>
                <div class="validate" v-if="errors.has('customer_id')">
                  {{ errors.first('customer_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.address')
                }}</label>
                <textarea
                  v-model="model.project_address"
                  class="form-control"
                  placeholder="Describe the place of you project"
                  rows="5"
                ></textarea>
                <div class="validate" v-if="errors.has('project_address')">
                  {{ errors.first('project_address') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.description')
                }}</label>
                <textarea
                  v-model="model.project_description"
                  placeholder="Describe any info for project"
                  class="form-control"
                  rows="13"
                ></textarea>
                <div class="validate" v-if="errors.has('project_description')">
                  {{ errors.first('project_description') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <br />
            <AttachFile v-model="attachment" />
            <div class="ts-w-full ts-col-span-3">
              <div class="ts-pl-3 ts-mt-3">
                <ul>
                  <li
                    v-for="(att, index) in updateData.attachments"
                    :key="index"
                  >
                    <button
                      class="ts-mr-2 hover:ts-text-red-600"
                      @click.prevent="deleteRecord(att.id)"
                    >
                      <Icon type="ios-trash-outline" size="18" />
                    </button>
                    <a href="#" @click.prevent="onClickViewFile(att)">{{
                      att.file_name
                    }}</a>
                    creaed by <b>{{ att.name }}</b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
          >
            <ts-button @click.prevent="$emit('cancel')">
              {{ $t('cancel') }}</ts-button
            >
            <ts-button color="primary" @click.prevent="onUpdate">
              {{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import AttachFile from './components/attach-file.vue'

export default {
  props: ['updateData'],
  components: {
    AttachFile
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      owners: [],
      customers: [],
      projectStatus: [],
      model: {
        project_id: '',
        project_code: '',
        project_name: '',
        project_address: '',
        project_owner: undefined,
        project_member: [],
        project_description: '',
        estimated_date: undefined,
        actual_date: undefined,
        customer_id: '',
        status_id: 1,
        priority_id: ''
      },
      attachment: {
        files: []
      }
    }
  },
  created() {
    this.fetchViewModel()
    this.errors = new Errors()
  },
  computed: {
    priorities() {
      return [
        {
          label: 'Low',
          value: 1
        },
        {
          label: 'Normal',
          value: 2
        },
        {
          label: 'Meduim',
          value: 3
        },
        {
          label: 'Hight',
          value: 4
        }
      ]
    }
  },
  methods: {
    ...mapActions('projectMgt/projectProfile', [
      'formViewModel',
      'update',
      'attachFile',
      'deleteAttachment'
    ]),
    fetchViewModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'customer,status,owner',
        project_id: this.updateData.project_id
      })
        .then(response => {
          this.owners = response.data.owner.map(el => ({
            value: el.user_id,
            label: el.employee_name_kh + '|' + el.employee_name_en
          }))
          this.customers = response.data.customer.map(el => ({
            value: el.customer_id,
            label: el.customer_name
          }))
          this.projectStatus = response.data.status.map(el => ({
            value: el.status_id,
            label: el.project_status
          }))
          this.setupData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onUpdate() {
      this.loading = true
      this.errors = new Errors()
      this.update({
        id: this.model.project_id,
        data: this.model
      })
        .then(response => this.onAttchmentFile().then(() => response))
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setupData() {
      this.model.project_id = this.updateData.project_id
      this.model.project_code = this.updateData.project_code
      this.model.project_name = this.updateData.project_name
      this.model.project_address = this.updateData.project_address
      this.model.project_owner = this.updateData.project_owner
      if (Array.isArray(this.updateData.project_member)) {
        this.model.project_member = this.updateData.project_member.map(
          el => el.user_id
        )
      } else {
        this.model.project_member = JSON.parse(
          this.updateData.project_member
        ).map(el => el.user_id)
      }
      this.model.project_description = this.updateData.project_description
      if (
        this.updateData.estimated_start_date &&
        this.updateData.estimated_end_date
      ) {
        this.model.estimated_date = [
          this.updateData.estimated_start_date,
          this.updateData.estimated_end_date
        ]
      }
      if (
        this.updateData.actual_start_date &&
        this.updateData.actual_end_date
      ) {
        this.model.actual_date = [
          this.updateData.actual_start_date,
          this.updateData.actual_end_date
        ]
      }
      this.model.customer_id = this.updateData.customer_id
      this.model.status_id = this.updateData.status_id
      this.model.priority_id = this.updateData.priority_id
    },
    async onAttchmentFile(id) {
      if (this.attachment.files.length) {
        let formData = new FormData()
        formData.append('model_id', id ? id : this.model.project_id)
        formData.append('model_type', 'project')
        for (var i = 0; i < this.attachment.files.length; i++) {
          let file = this.attachment.files[i]
          formData.append('files[' + i + ']', file)
        }
        await this.attachFile(formData)
        this.attachment.files = []
      }

      return new Promise(r => r('done'))
    },
    onClickViewFile(att) {
      window.open(att.file_path, '_blank', 'noreferrer')
    },
    deleteRecord(id) {
      this.$confirm({
        title: this.$t('task.are_you_want_to_delete_it_cant_redo'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.deleteAttachment(id)
            .then(response => {
              this.$emit('fetch')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    }
  }
}
</script>
